<template>
    <div class="modal fade" :id="idModalData" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">EMBARCACION {{ ship.nameShip }} </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="brand_engine" class="badge badge-primary">Matricula</label>
                                <input type="text" class="form-control-plaintext" disabled v-model="ship.enrollment" name="flag" placeholder="Sin registro" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="model_engine" class="badge badge-primary">Antigua Matricula</label>
                                <input type="text" class="form-control-plaintext" disabled v-model="ship.enrollment_old" name="model_engine" placeholder="Sin Registro" autocomplete="off">
                            </div>                        
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="rpm_engine" class="badge badge-primary">Tipo</label>
                                <input type="text" class="form-control-plaintext" disabled v-model="ship.type" name="flag" placeholder="Hp por RPM" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="serie_engine" class="badge badge-primary">Propulsion</label>
                                <input type="text" class="form-control-plaintext" disabled v-model="ship.propulsion" name="model_engine" placeholder="Serie Motor" autocomplete="off">
                            </div>                    
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="combustible_construction" class="badge badge-primary">TRN</label>
                                <input type="text" class="form-control-plaintext" v-model="ship.trn" name="model_engine" placeholder="Serie Motor" disabled autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="engine_autonomia" class="badge badge-primary">TRB</label>
                                <input type="text" class="form-control-plaintext" v-model="ship.trb" name="model_engine" placeholder="Autonomia Motor" disabled autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="engine_velocity" class="badge badge-primary">Capitania</label>
                                <input type="text" class="form-control-plaintext" v-model="ship.port" placeholder="Puerto" disabled >
                            </div>
                        </div>                                           
                            
                    </div>               
                    
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>                        
                    </div>
                </div>
            </div>
            
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

const qs= require('qs');


export default {
    name:'modal-ship',
    props:{
        ship:Object,
        idModalData:String,
        nameShip:String
    },
    data(){
        return {
            btnSend:false
        }
    },
    methods:{
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/matriculacion/ViewDtsShip.vue